import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EqualtecContainer } from './equaltec-container/EqualtecContainer.component';
import { EqualtecHome } from './equaltec-home/EqualtecHome.component';
import { EqualtecProcesses} from './equaltec-processes/EqualtecProcesses.component';
import { EqualtecComponent } from './equaltec.component';
import { EqualtecRoutingModule } from "./equaltec-routing";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from '@angular/forms';
import { EqualtecFilterClass } from './equaltec.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { EqualtecTopbar } from "./equaltec-topbar/EqualtecTopbar.component";
import { EqualtecFavorites } from "./equaltec-favorites/EqualtecFavorites.component";
import { EqualtecEvidence } from "./equaltec-evidence/EqualtecEvidence.component";
import { EqualtecSearch } from "./equaltec-search/EqualtecSearch.component";
import { EqualtecLink} from "./equaltec-link/EqualtecLink.component";
import { EqualtecModal } from "./equaltec-modal/EqualtecModal.component";
import { EqualtecCompliance } from "./equaltec-compliance/EqualtecCompliance.component";
import { EqualtecdetailComponent } from "../equaltec-detail/equaltec-detail.component";
import { EqualtecModalPresavisioneComponent } from './equaltec-modal-presavisione/equaltec-modal-presavisione.component';


@NgModule({

  declarations: [
    EqualtecTopbar,
    EqualtecContainer,
    EqualtecComponent,
    EqualtecFavorites,
    EqualtecEvidence,
    EqualtecHome,
    EqualtecSearch,
    EqualtecLink,
    EqualtecModal,
    EqualtecProcesses,
    EqualtecCompliance,
    EqualtecFilterClass,
    EqualtecdetailComponent,
    EqualtecModalPresavisioneComponent ],
  imports: [
    CommonModule,
    EqualtecRoutingModule,
    NgbModule,
    TranslateModule,
    FormsModule,
    BrowserModule
  ],
})


export class EqualtecModule { }
